import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>
                Created by Spencer Davis, Luz De La Rosa, Ryan Shao, Maria Lujan Vinas &copy; 2020
            </p>
        </footer>
    )
}

export default Footer; 